export const CONTAINER_WIDTH = "560px";
export const CONTAINER_FULL_WIDTH = "100vw";

export const TAB_WIDTH = "55vw";
